import { render } from "./TheTradeGroup.vue?vue&type=template&id=e954f8ae&ts=true"
import script from "./TheTradeGroup.vue?vue&type=script&lang=ts"
export * from "./TheTradeGroup.vue?vue&type=script&lang=ts"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__